<h2 class="show-for-medium">Not Found</h2>
<hr class="divider show-for-medium">
<p>
  <app-text [alias]="'not_found_component'"></app-text>
</p>